import { render, staticRenderFns } from "./heliodDetailList.vue?vue&type=template&id=61a9fdb8&"
import script from "./heliodDetailList.vue?vue&type=script&lang=js&"
export * from "./heliodDetailList.vue?vue&type=script&lang=js&"
import style0 from "./heliodDetailList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports